<template>
    <div style="text-align:center;padding-top:50px;color:#999;">
        <h2>下面是NODE后端接口来的数据：</h2>
        <table border="0" bgcolor="#000" cellpadding="10" cellspacing="1" width="90%" style="margin:0px auto;">
            <thead>
                <tr>
                    <th bgcolor="#fff">ID</th>
                    <th bgcolor="#fff">名字</th>
                    <th bgcolor="#fff">电话</th>
                    <th bgcolor="#fff">创建时间</th>
                </tr>
            </thead>
            <tbody>
                <!-- 在Vue组件中，我们可以使用v-for指令来遍历这个数组并展示每一项，这里使用了:key="item.id"来为每个列表项提供一个唯一的键 -->
                <tr v-for="item in items" :key="item.id">
                    <td bgcolor="#fff">{{item.id}}</td>
                    <td bgcolor="#fff">{{item.username}}</td>
                    <td bgcolor="#fff">{{item.phone}}</td>
                    <td bgcolor="#fff">{{item.register_time}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'RequestInfo',
        data () {
            return {
                items: [] // 初始化为空数组，用于存放从后端获取的数据
            }
        },
        mounted () {
            axios
                .get('/api/data')// 注意这里本地调试时只需要写 /api/data，本地调试路径在vue.config.js进行了代理配置
                .then(response => {
                    this.items = response.data;// 确保response.data是一个数组
                    console.log(this.items, typeof response.data);// 使用this.items来访问数据
                })
                .catch(error => { // 请求失败处理
                    // 先检查了 error.response，如果存在，说明服务器返回了一个错误响应，打印出服务器返回的错误消息
                    if (error.response) {
                        // 请求已经发出，但服务器返回了一个非 2xx 的状态码
                        console.error(error.response.data.message);
                        // error.response.data 是服务器返回的响应体
                        // error.response.data.error 是你的错误消息
                    }
                    // 否则如果error.request 存在，那么说明请求已经发出，但没有收到响应，打印出相关错误信息
                    else if (error.request) {
                        // 请求已经发出，但没有收到响应
                        // `error.request` 是在浏览器中的 XMLHttpRequest 实例，在 Node.js 中是 http.ClientRequest 实例
                        console.error('No response was received', error.request);
                    }
                    // 如果两者都不存在，直接打印发送请求时的错误信息
                        else {
                        // 发送请求时出现了一些问题
                        console.error('Error', error.message);
                    }
                });
        }
    }
</script>

<style>
    table td {
        word-break: break-all;
    }
</style>